/**
 * WA0182 · Campana global de correos de obra sin leer.
 * Se refresca cada 60s. Al pulsar navega a la obra más reciente con correos.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import api from "@/lib/api";

export default function CorreosObraBell() {
  const [data, setData] = useState({ total: 0, ultimos: [] });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data: r } = await api.get("/obra-correos/no-leidos-global");
        if (alive) setData(r || { total: 0, ultimos: [] });
      } catch { /* silent */ }
    };
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  const total = data.total || 0;

  return (
    <div className="relative">
      <button onClick={() => setOpen((o) => !o)}
              data-testid="topbar-correos-obra-bell"
              title={`${total} correo(s) de obra sin leer`}
              className="inline-flex items-center justify-center h-9 w-9 rounded-full hover:bg-black/[0.05] dark:hover:bg-white/[0.06] text-[var(--legatum-text-muted)] hover:text-[var(--legatum-text)] transition-colors relative">
        <Mail className="h-4 w-4" />
        {total > 0 && (
          <>
            <span className="absolute top-1 right-1 h-2 w-2 rounded-full bg-[#DC2626] animate-ping" />
            <span className="absolute top-1 right-1 h-2 w-2 rounded-full bg-[#DC2626]" />
            <span className="absolute -bottom-0.5 right-0 text-[8px] font-extrabold px-1 rounded-full bg-[#DC2626] text-white tabular-nums leading-none py-0.5"
                  data-testid="topbar-correos-obra-count">
              {total > 99 ? "99+" : total}
            </span>
          </>
        )}
      </button>
      {open && (
        <div className="absolute right-0 top-11 z-50 w-80 rounded-xl border border-[var(--legatum-border)] bg-[var(--legatum-surface)] shadow-2xl overflow-hidden"
             data-testid="topbar-correos-obra-panel">
          <div className="px-3 py-2 border-b border-[var(--legatum-border)] flex items-center justify-between">
            <span className="text-xs font-extrabold uppercase tracking-widest text-[var(--legatum-text)]">Correos de obra sin leer</span>
            <span className="text-[10px] font-bold text-[var(--legatum-text-muted)] tabular-nums">{total}</span>
          </div>
          <div className="max-h-80 overflow-y-auto">
            {(data.ultimos || []).length === 0 ? (
              <div className="text-xs italic text-[var(--legatum-text-muted)] p-3 text-center">Todo al día.</div>
            ) : data.ultimos.map((c, i) => (
              <Link key={i} to={`/obras/${c.obra_id}`} onClick={() => setOpen(false)}
                    data-testid={`topbar-correos-obra-item-${i}`}
                    className="block px-3 py-2 border-b border-[var(--legatum-border)] hover:bg-[var(--legatum-elevated)]/50 last:border-b-0">
                <div className="text-xs font-extrabold truncate">{c.asunto}</div>
                <div className="text-[10px] text-[var(--legatum-text-muted)] flex items-center gap-2">
                  <span className="font-bold">{c.obra_codigo}</span>
                  {c.fecha && <span>· {c.fecha.slice(0, 16).replace("T", " ")}</span>}
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
